import { constantsData, formFieldNamesData, optionsData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    businessType: businessTypeFieldName,
    city: cityFieldName,
    companyEmail: companyEmailFieldName,
    companyName: companyNameFieldName,
    companyStructure: companyStructureFieldName,
    companyWebsite: companyWebsiteFieldName,
    country: countryFieldName,
    currency: currencyFieldName,
    employees: employeesFieldName,
    firstName: firstNameFieldName,
    industrySector: industrySectorFieldName,
    lastName: lastNameFieldName,
    operationRegion: operationRegionFieldName,
    postalCode: postalCodeFieldName,
    state: stateFieldName,
    status: statusFieldName,
    streetAddress: streetAddressFieldName,
    subscriptionPlan: subscriptionPlanFieldName,
} = formFieldNamesData;

const {
    businessType,
    city,
    companyEmail,
    companyName,
    companyStructure,
    companyWebsite,
    country,
    currency,
    employees,
    firstName,
    industrySector,
    lastName,
    operationRegion,
    postalCode,
    state,
    status,
    streetAddress,
    subscriptionPlan,
    subscriptionType,
} = constantsData.forms.organizations.organization;

export const adminOrganizationFormData = [
    {
        fields: [
            {
                isMini: true,
                isOptional: true,
                label: firstName.label,
                name: firstNameFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                isMini: true,
                isOptional: true,
                label: lastName.label,
                name: lastNameFieldName,
                type: InputTypeEnum.TEXT,
            },
        ],
        groupTitle: constantsData.titles.userInfo,
        isRowGroup: true,
    },
    {
        fields: [
            {
                isMini: true,
                isOptional: false,
                label: companyName.label,
                name: companyNameFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                isMini: true,
                isOptional: false,
                label: companyEmail.label,
                name: companyEmailFieldName,
                type: InputTypeEnum.EMAIL,
            },
        ],
        groupTitle: constantsData.titles.companyInfo,
        isRowGroup: true,
    },
    {
        fields: [
            {
                dataKey: AsyncDataKeyEnum.STRUCTURES,
                hasOptionFormat: true,
                isAsync: true,
                isMini: true,
                isOptional: false,
                label: companyStructure.label,
                name: companyStructureFieldName,
                type: FieldTypeEnum.SELECT,
            },
            {
                isMini: true,
                isOptional: false,
                label: businessType.label,
                name: businessTypeFieldName,
                type: InputTypeEnum.TEXT,
            },
        ],
        isRowGroup: true,
    },
    {
        fields: [
            {
                isMini: true,
                isOptional: true,
                label: industrySector.label,
                name: industrySectorFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                isMini: true,
                isOptional: true,
                label: companyWebsite.label,
                name: companyWebsiteFieldName,
                type: InputTypeEnum.TEXT,
            },
        ],
        isRowGroup: true,
    },
    {
        fields: [
            {
                dataKey: AsyncDataKeyEnum.CURRENCIES,
                isAsync: true,
                isMini: true,
                isOptional: false,
                label: currency.label,
                name: currencyFieldName,
                type: FieldTypeEnum.SELECT,
            },
            {
                hasOptionFormat: true,
                label: subscriptionPlan.label,
                name: subscriptionPlanFieldName,
                options: optionsData.organization.subscriptionPlans,
                type: FieldTypeEnum.SELECT,
            },
        ],
        isRowGroup: true,
    },
    {
        fields: [
            {
                isMini: true,
                isOptional: true,
                label: streetAddress.label,
                name: streetAddressFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                dataKey: AsyncDataKeyEnum.COUNTRIES,
                isAsync: true,
                isMini: true,
                isOptional: true,
                label: country.label,
                name: countryFieldName,
                type: FieldTypeEnum.SELECT,
            },
        ],
        groupTitle: constantsData.titles.companyAddress,
        isRowGroup: true,
    },
    {
        fields: [
            {
                isMini: true,
                isOptional: true,
                label: city.label,
                name: cityFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                isMini: true,
                isOptional: true,
                label: state.label,
                name: stateFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                isMini: true,
                isOptional: true,
                label: postalCode.label,
                name: postalCodeFieldName,
                type: InputTypeEnum.TEXT,
            },
        ],
        isRowGroup: true,
    },
    {
        fields: [
            {
                hasOptionFormat: true,
                isMini: true,
                isOptional: true,
                label: employees.label,
                name: employeesFieldName,
                options: optionsData.organization.employeeNumbers,
                type: FieldTypeEnum.SELECT,
            },
            {
                dataKey: AsyncDataKeyEnum.REGIONS,
                hasOptionFormat: true,
                isAsync: true,
                isMini: true,
                isOptional: false,
                label: operationRegion.label,
                name: operationRegionFieldName,
                type: FieldTypeEnum.SELECT,
            },
        ],
        groupTitle: constantsData.titles.operationInfo,
        isRowGroup: true,
    },
    {
        description: status.description,
        hasOptionFormat: true,
        isRowGroup: false,
        label: status.label,
        name: statusFieldName,
        options: optionsData.organization.status.options,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: subscriptionType.description,
        hasOptionFormat: true,
        isRowGroup: false,
        label: subscriptionType.label,
        name: subscriptionPlanFieldName,
        options: optionsData.organization.subscriptionPlans,
        type: FieldTypeEnum.SELECT,
    },
];
